import { Component,  Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { ToastSnack } from './toast.models';
import { trigger, style, transition, animate, keyframes } from '@angular/animations';
import * as kf from 'src/app/core/animations/keyframes';

@Component({
  selector: 'gio-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  animations: [
    // the fade-in/fade-out animation.
    trigger('toastAnimation', [

      // // fade out when destroyed. this could also be written as transition('void => *')
      transition(':enter', animate(600, keyframes(kf.slideInUp))),
      transition(':leave', animate(600, style({ height: 0 })))
      // transition(':leave', animate(600, keyframes(kf.slideOutUp)))
    ])

  ]
})
export class ToastComponent {

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: ToastSnack[]
  ) { }

  actionCalled(action: ToastSnack) {
    if (this.data && this.data.length > 0) {
      if (action.onAction) {
        action.onAction();
      }
    }
  }

}
